/**
 * Crisp Chat Message Saver
 * Sends only when a message is sent or received in Crisp (no visit/chat-opened notifications).
 *
 * API: {origin}/apps/ryzo/search/shop-message/
 * Crisp Website ID: 815a498d-c70c-47d2-bad5-f97cd08abcec
 */

(function () {
  'use strict';

  function getApiEndpoint() {
    var origin = window.location.origin;
    return origin + '/apps/ryzo/search/shop-message/';
  }

  function getShopUrl() {
    try {
      var params = new URLSearchParams(window.location.search);
      var shopParam = params.get('shop');
      if (shopParam) return shopParam;
    } catch (e) { /* ignore */ }

    try {
      var stored = localStorage.getItem('shop');
      if (stored) return stored;
    } catch (e) { /* ignore */ }

    if (window.Shopify && window.Shopify.shop) {
      return window.Shopify.shop;
    }

    return 'ryzo-shop.myshopify.com';
  }

  function convertImageToBase64(url) {
    return new Promise(function (resolve, reject) {
      var img = new Image();
      img.crossOrigin = 'Anonymous';
      img.onload = function () {
        try {
          var canvas = document.createElement('canvas');
          canvas.width = img.naturalWidth;
          canvas.height = img.naturalHeight;
          var ctx = canvas.getContext('2d');
          ctx.drawImage(img, 0, 0);
          resolve(canvas.toDataURL('image/png'));
        } catch (e) {
          reject(e);
        }
      };
      img.onerror = function () {
        reject(new Error('Failed to load image: ' + url));
      };
      img.src = url;
    });
  }

  function sendMessageToAPI(message) {
    var shopUrl = getShopUrl();
    if (!shopUrl) {
      console.warn('Could not send message to API - missing shop URL');
      return;
    }

    fetch(getApiEndpoint(), {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json'
      },
      body: JSON.stringify({
        shop_url: shopUrl,
        message: message
      })
    })
      .then(function (response) {
        if (response.ok) {
          console.log('Event saved:', message.substring(0, 80) + (message.length > 80 ? '...' : ''));
        } else {
          console.warn('Failed to send message to API:', response.status);
        }
      })
      .catch(function (error) {
        console.warn('Failed to send message to API:', error);
      });
  }

  function getSenderType(data) {
    if (!data || !data.from) return 'User';
    var from = String(data.from).toLowerCase();
    return from === 'operator' ? 'Operator' : 'User';
  }

  function handleCrispMessage(data) {
    if (!data || typeof data !== 'object') return;

    var senderType = getSenderType(data);
    var type = (data.type && String(data.type)) || 'text';
    var formattedMessage;

    switch (type) {
      case 'text': {
        var content = (data.content != null && data.content !== '') ? data.content : (data.message != null && data.message !== '') ? data.message : (data.text != null && data.text !== '') ? data.text : '';
        formattedMessage = '[' + senderType + ' Message]: ' + content;
        sendMessageToAPI(formattedMessage);
        break;
      }

      case 'file': {
        var mimeType = data.type ? String(data.type) : '';
        var isImageFile = mimeType.indexOf('image') === 0 && data.url;
        if (isImageFile) {
          convertImageToBase64(data.url)
            .then(function (base64) {
              sendMessageToAPI('[' + senderType + ' sent image - Base64]:\n' + base64);
            })
            .catch(function () {
              sendMessageToAPI('[' + senderType + ' sent ' + mimeType + ']: ' + (data.name || 'file') + ' - ' + data.url);
            });
        } else {
          formattedMessage = '[' + senderType + ' sent ' + (mimeType || 'application/octet-stream') + ']: ' + (data.name || 'file') + ' - ' + (data.url || '');
          sendMessageToAPI(formattedMessage);
        }
        break;
      }

      case 'image': {
        var imgUrl = data.url || data.content || data.src || '';
        if (imgUrl) {
          convertImageToBase64(imgUrl)
            .then(function (base64) {
              sendMessageToAPI('[' + senderType + ' sent image - Base64]:\n' + base64);
            })
            .catch(function () {
              sendMessageToAPI('[' + senderType + ' sent image]: ' + imgUrl);
            });
        } else {
          formattedMessage = '[' + senderType + ' sent image]: ' + JSON.stringify(data);
          sendMessageToAPI(formattedMessage);
        }
        break;
      }

      case 'animation': {
        var animUrl = (typeof data.url === 'string') ? data.url : (data.content && typeof data.content === 'string') ? data.content : '';
        formattedMessage = '[' + senderType + ' sent animation]: ' + (animUrl || JSON.stringify(data));
        sendMessageToAPI(formattedMessage);
        break;
      }

      default:
        formattedMessage = '[' + senderType + ' sent ' + type + ']: ' + JSON.stringify(data);
        sendMessageToAPI(formattedMessage);
        break;
    }
  }

  function setupCrispListeners() {
    window.$crisp.push(['on', 'message:sent', function (data) {
      handleCrispMessage(data);
    }]);

    window.$crisp.push(['on', 'message:received', function (data) {
      handleCrispMessage(data);
    }]);

    console.log('Crisp Message Saver: Listeners initialized for ' + getShopUrl());
  }

  function initCrispMessageSaver() {
    if (window.$crisp && typeof window.$crisp.push === 'function') {
      setupCrispListeners();
      return;
    }

    var attempts = 0;
    var maxAttempts = 60;
    var interval = setInterval(function () {
      attempts++;
      if (window.$crisp && typeof window.$crisp.push === 'function') {
        clearInterval(interval);
        setupCrispListeners();
      } else if (attempts >= maxAttempts) {
        clearInterval(interval);
        console.warn('Crisp Message Saver: Crisp did not load within 30 seconds.');
      }
    }, 500);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initCrispMessageSaver);
  } else {
    initCrispMessageSaver();
  }

})();
